import { Skeleton, Stack, styled } from "@mui/material";
import useBreakpoints from "hooks/useBreakpoint";

const FullySupplierSkeleton = () => {
  const { isMobile } = useBreakpoints();

  return (
    <StyledFullySupplierSkeleton
      spacing={1}
      direction="row"
      className="card border"
    >
      <Stack width={{ xs: "100%", md: "60%" }} spacing={0.5}>
        <Stack direction="row" spacing={0.5}>
          <Skeleton variant="rounded" height={60} width={60} />
          <Stack flex={1}>
            <Skeleton variant="text" height={20} width="70%" />
            <Skeleton variant="text" height={20} width="100%" />
            <Skeleton variant="text" height={20} width="50%" />
          </Stack>
        </Stack>
        <Skeleton variant="text" height={20} width="50%" />
        <Skeleton variant="text" height={20} width={60} />
        <Skeleton variant="text" height={20} width={148} />
      </Stack>

      {!isMobile && (
        <Stack
          width="40%"
          direction="row"
          spacing={1}
          justifyContent="flex-end"
        >
          <Skeleton variant="rounded" height={164} width={250} />
        </Stack>
      )}
    </StyledFullySupplierSkeleton>
  );
};

const StyledFullySupplierSkeleton = styled(Stack)(({ theme }) => ({
  "&, .rfq": {},
  ".rfq": {
    padding: 8,
    flex: 1,
  },

  [theme.breakpoints.down("md")]: {
    padding: 8,
  },
}));

export default FullySupplierSkeleton;
